import type { SorterResult } from "antd/lib/table/interface";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "../../../../../components";
import { displayStatusValue } from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { DccProfileEntity } from "../../types/DccProfileEntity";

export const DccProfilesTable: FC<ResourceTableProps<DccProfileEntity>> = ({
    onStateChanged,
    onRowSelectionChange,
    datasource,
    resource,
}) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<DccProfileEntity>): ExtendedColumnsType<DccProfileEntity>[] => {
            return [
                {
                    title: t("dccProfile.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("dccProfile.name"),
                    key: "name",
                    dataIndex: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("dccProfile.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: DccProfileEntity) => {
        navigate(`${BASE_PATH}/${ResourceName.DCC_PROFILES}/${FORM_ACTION.EDIT}/${record.id}`);
    };

    return (
        (datasource && (
            <GenericTable<DccProfileEntity>
                name="dccProfiles_table"
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: DccProfileEntity) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
